import { Action, createReducer, on } from '@ngrx/store';
import { ComplianceInfoState } from 'src/app/compliance/store/state/compliance-info.state';

import * as actions from 'src/app/compliance/store/actions/compliance.actions';
import * as documentReviewerActions from 'src/app/compliance/store/actions/document-reviewer.actions';

export const initialState: ComplianceInfoState = {
    candidateInfo: undefined,
    complianceLiaisons: [],
    credentialingSpecialists: [],
    error: '',
    filteredCredentialingSpecialists: [],
    facilityContractAssignment: undefined,
    isLoading: false,
    liaisonFacilityContractAssignment: undefined,
    liaisonQmContractAssignment: undefined,
    permissions: undefined,
    router: undefined
};

const reducer = createReducer(
    initialState,

    on(actions.filterCredentialingSpecialists, (state, action) => ({
        ...state,
        filteredCredentialingSpecialists: state.credentialingSpecialists.filter((cred) =>
            cred.name.toLowerCase().startsWith(action.filterVal.toLowerCase())
        )
    })),

    on(documentReviewerActions.loadCandidateInformationSuccess, (state, action) => ({
        ...state,
        candidateInfo: action.candidateInfo
    })),

    on(documentReviewerActions.loadCandidateInformationFailure, (state, action) => ({
        ...state,
        candidateInfo: undefined
    })),

    on(actions.loadCompliancePermissionsSuccessfully, (state, action) => ({
        ...state,
        permissions: action.permissions
    })),

    on(actions.loadCompliancePermissionsFailure, (state, action) => ({
        ...state,
        permissions: undefined,
        error: JSON.stringify(action.error)
    })),

    on(actions.updateCredentialingSpecialistFromPrestartGrid, (state) => ({
        ...state,
        isLoading: true
    })),

    on(
        actions.updateContractCredentialingSpecialist,
        actions.updateContractComplianceLiaison,
        actions.unassignComplianceLiaisonFromCLEditReport,
        actions.unassignCredentialingSpecialistFromCSEditReport,
        (state) => ({
            ...state,
            isLoading: true
        })
    ),

    on(actions.updateCandidateCredentialingSpecialistFromTeamInfo, (state) => ({
        ...state,
        isLoading: true
    })),

    on(actions.bulkUpdateCredentialingSpecialist, (state) => ({
        ...state,
        isLoading: true
    })),

    on(actions.bulkUpdateCredentialingSpecialistSuccess, (state) => ({
        ...state,
        isLoading: false,
        error: undefined
    })),

    on(actions.bulkUpdateCredentialingSpecialistFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: JSON.stringify(action.error)
    })),

    on(actions.bulkUnassignCredentialingSpecialist, (state) => ({
        ...state,
        isLoading: true
    })),

    on(actions.bulkUnassignCredentialingSpecialistSuccess, (state) => ({
        ...state,
        isLoading: false,
        error: undefined
    })),

    on(
        actions.bulkUnassignCredentialingSpecialistFailure,
        actions.bulkUpdateCredentialingSpecialistFailure,
        actions.updateContractCredentialingSpecialistFailure,
        actions.updateContractComplianceLiaisonFailure,
        actions.unassignComplianceLiaisonFromCLEditReportFailure,
        (state, action) => ({
            ...state,
            isLoading: false,
            error: JSON.stringify(action.error)
        })
    ),

    on(
        actions.updateCandidateCredentialingSpecialistSuccessfully,
        actions.updateContractComplianceLiaisonSuccessfully,
        actions.unassignComplianceLiaisonFromCLEditReportSuccessfully,
        actions.unassignCredentialingSpecialistFromCSEditReportSuccess,
        (state) => ({
            ...state,
            isLoading: false
        })
    ),

    on(actions.updateContractCredentialingSpecialistSuccessfully, (state) => ({
        ...state,
        isLoading: false
    })),

    on(actions.loadCredentialingSpecialistsSuccessfully, (state, action) => ({
        ...state,
        credentialingSpecialists: action.credentialingSpecialists,
        error: undefined,
        isLoading: false
    })),

    on(actions.loadCredentialingSpecialistsFailure, (state, action) => ({
        ...state,
        credentialingSpecialists: [],
        error: JSON.stringify(action.error),
        isLoading: false
    })),

    on(actions.loadComplianceLiaisonsSuccessfully, (state, action) => ({
        ...state,
        complianceLiaisons: action.complianceLiaisons,
        error: undefined,
        isLoading: false
    })),

    on(actions.loadComplianceLiaisonsFailure, (state, action) => ({
        ...state,
        complianceLiaisons: [],
        error: JSON.stringify(action.error),
        isLoading: false
    })),

    on(actions.loadFacilityAssignmentByFacilityId, (state) => ({
        ...state,
        isLoading: true
    })),

    on(actions.loadFacilityAssignmentByFacilityIdSuccessfully, (state, action) => ({
        ...state,
        facilityContractAssignment: action.assignment,
        isLoading: false
    })),

    on(actions.loadFacilityAssignmentByFacilityIdFailure, (state, action) => ({
        ...state,
        facilityContractAssignment: undefined,
        isLoading: false,
        error: JSON.stringify(action.error)
    })),

    on(actions.updateFacilityAssignmentByFacilityId, (state) => ({
        ...state,
        isLoading: true
    })),

    on(actions.updateFacilityAssignmentByFacilityIdSuccessfully, (state) => ({
        ...state,
        isLoading: false
    })),

    on(actions.updateFacilityAssignmentByFacilityIdFailure, (state, action) => ({
        ...state,
        isLoading: false,
        error: JSON.stringify(action.error)
    })),

    on(actions.loadLiaisonFacilityAssignmentByFacilityId, (state) => ({
        ...state,
        isLoading: true
    })),

    on(actions.loadLiaisonFacilityAssignmentByFacilityIdSuccessfully, (state, action) => ({
        ...state,
        liaisonFacilityContractAssignment: action.assignment,
        isLoading: false
    })),

    on(actions.loadLiaisonFacilityAssignmentByFacilityIdFailure, (state, action) => ({
        ...state,
        liaisonFacilityContractAssignment: undefined,
        isLoading: false,
        error: JSON.stringify(action.error)
    })),

    on(
        actions.updateLiaisonFacilityAssignmentByFacilityId,
        actions.unassignComplianceLiaisonFromFacilityProfile,
        (state) => ({
            ...state,
            isLoading: true,
            error: undefined
        })
    ),

    on(actions.updateLiaisonFacilityAssignmentByFacilityIdSuccessfully, (state, action) => ({
        ...state,
        isLoading: false
    })),

    on(
        actions.updateLiaisonFacilityAssignmentByFacilityIdFailure,
        actions.loadLiaisonQmAssociationAssignmentByAssociationIdFailure,
        actions.unassignComplianceLiaisonFromFacilityProfileFailure,
        actions.unassignComplianceLiaisonFromAssociationProfileFailure,
        (state, action) => ({
            ...state,
            isLoading: false,
            error: JSON.stringify(action.error)
        })
    ),

    on(actions.loadLiaisonQmAssociationAssignmentByAssociationId, (state) => ({
        ...state,
        isLoading: true
    })),

    on(actions.loadLiaisonQmAssociationAssignmentByAssociationIdSuccessfully, (state, action) => ({
        ...state,
        isLoading: false,
        liaisonQmContractAssignment: action.assignment,
        error: undefined
    }))
);

export function complianceInfoReducer(state: ComplianceInfoState | undefined, action: Action) {
    return reducer(state, action);
}
